import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { SHOP_SUPPLIES_CLICKED } from '../../constants/analytics-events';
import { CountryConfigNames } from '../../contexts/country-config-context/country-config-enums';
import { useCountryConfig } from '../../hooks/use-country-config';
import { Segment } from '../../services/analytics-services/segment';

const POPULAR = 'POPULAR';
const PRINTING = 'PRINTING';
const HELP_MENU = 'HELP_MENU';
const baseLink = 'https://supplies.shipstation.com/?';

const settingsPopularLink = {
  utm_source: 'shipstation+client',
  utm_medium: 'settings',
  utm_campaign: 'supplies+banner',
};
const printSettingsLink = {
  utm_source: 'shipstation+client',
  utm_medium: 'printing+setup',
  utm_campaign: 'supplies+banner',
};

const helpMenuLink = {
  utm_source: 'shipstation+client',
  utm_medium: 'support+resources',
  utm_campaign: 'dropdown-menu',
};

const linkMap = {
  POPULAR: settingsPopularLink,
  PRINTING: printSettingsLink,
  HELP_MENU: helpMenuLink,
};

const useShippingSuppliesLink = (consumerName) => {
  const [shippingSuppliesLinkEnabled] = useCountryConfig(CountryConfigNames.ShippingSuppliesLinkEnabled);
  const enableShippingSuppliesLink = useSelector((state) => state?.featureFlags?.enableShippingSuppliesLink);
  const isShippingSuppliesLinkEnabled = shippingSuppliesLinkEnabled && enableShippingSuppliesLink;
  const searchParams = new URLSearchParams(linkMap[consumerName]);
  const link = `${baseLink}${searchParams}`;

  const onShippingSuppliesLinkClicked = useCallback(() => {
    const consumer = linkMap[consumerName];
    Segment.trackEvent(SHOP_SUPPLIES_CLICKED, consumer);
  }, [consumerName]);

  return {
    isShippingSuppliesLinkEnabled,
    suppliesStoreLink: link,
    onShippingSuppliesLinkClicked,
  };
};

export { HELP_MENU, POPULAR, PRINTING, useShippingSuppliesLink };
